import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

import PasswordInput from '../Enter/fields/PasswordInput';
import SubmitButton from '../Enter/fields/SubmitButton';
import Spacer from '../common/Spacer';

import useQuery from '../../utils/useQuery';
import { validateLength } from '../../utils/validation';
import { authHttp, loginHttp } from '../../utils/http';
import { genericErrorMessage } from '../../utils/lang/commonErrors';

import styles from './SetPasswordForm.scss';

const SetPasswordForm = () => {
  const history = useHistory();
  const intl = useIntl();
  const { token } = useQuery();

  const [passInput, setPassInput] = useState('');
  const onPassInputChange = (e) => setPassInput(e.target.value);

  const [isLoading, setLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const onSubmit = () => {
    setLoading(true);
    const passError = validateLength(passInput, 8, 21);

    if (!passError) {
      loginHttp('/v1/account/sign-in/perm-token', { perm_token: token })
        .then(
          () => authHttp('/v1/account/set-password', 'POST', {
            new_password: passInput
          }, false),
          () => {
            setFormErrors({
              pass: intl.formatMessage(genericErrorMessage)
            });
            setLoading(false);
          }
        )
        .then(
          () => {
            history.push('/profile');
          },
          () => {
            setFormErrors({
              pass: intl.formatMessage(genericErrorMessage)
            });
            setLoading(false);
          }
        );
    } else {
      setFormErrors({
        pass: passError
      });
      setLoading(false);
    }
  };

  return (
    <form className={styles.form}>
      <h2 className={styles.title}>
        <FormattedMessage
          id="setPassword.title"
          defaultMessage="Set password"
          description="Title of the page where user sets the password for their newly created account"
        />
      </h2>

      <span className={styles.subtitle}>
        <FormattedMessage
          id="setPassword.subtitle"
          defaultMessage="Create password to setup an account"
          description="Subtitle of the page where user sets the password for their newly created account"
        />
      </span>
      <Spacer height={5} />

      <PasswordInput
        passValue={passInput}
        onChange={onPassInputChange}
        error={formErrors.pass}
        label={intl.formatMessage({
          id: 'setPassword.passwordFieldLabel',
          defaultMessage: 'Create your password',
          description: 'Label for password field, where user creates new password for the account'
        })}
      />

      <SubmitButton
        text={intl.formatMessage({
          id: 'setPassword.submitButton',
          defaultMessage: 'Sign up',
          description: 'Button that completes the sign up flow by setting the password for the new account, forwarding use to their new profile'
        })}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </form>
  );
};

export default SetPasswordForm;
